module.exports = __webpack_public_path__ + "ally-book.bfe408904df80538ed2d.svg";


//////////////////
// WEBPACK FOOTER
// /home3/usalinks/public_html/ally-book-source/src/assets/less/icons/font/ally-book.svg?92208573
// module id = ../../../../../src/assets/less/icons/font/ally-book.svg?92208573
// module chunks = styles